<div class="auth-form-container">
  <div class="auth-form-wrapper">
    <!-- Right Section -->
    <div class="auth-form-right"
      [class.login-form]="isRegister === 1"
      [class.reset-form]="isRegister === 2"
      [class.reset-confirm-form]="isRegister === 3"
      [class.mfa-form]="isRegister === 4"
    >
    <!-- White content wrapper -->
    <div class="form-content-wrapper">

    <!-- Brand -->
    <div class="auth-brand">
      <img class="auth-brand__symbol" src="assets/layout/images/branding/gainkode-simbolo.svg" [alt]="'brand.name' | transloco" />
      <span class="auth-brand__name">{{ 'layout.pulso.brand' | transloco }}</span>
    </div>

    @if (!showSuccessState) {
      <!-- Title -->
      <div class="form-titles">
        <h1 class="form-header">
          @if (isRegister === 1) {
            {{ 'auth.login.title' | transloco }}
          } @else if (isRegister === 2) {
            {{ 'auth.resetPassword.title' | transloco }}
          } @else if (isRegister === 3) {
            {{ 'auth.resetPasswordConfirm.title' | transloco }}
          } @else if (isRegister === 4) {
            {{ 'auth.login.mfa.title' | transloco }}
          }
        </h1>
        <p class="form-subtitle">
          @if (isRegister === 1) {
            {{ 'auth.login.subtitle' | transloco }}
          } @else if (isRegister === 2) {

          } @else if (isRegister === 3) {
            {{ 'auth.resetPasswordConfirm.subtitle' | transloco }}
          } @else if (isRegister === 4) {
            {{ 'auth.login.mfa.description' | transloco }}
          }
        </p>
      </div>

    <!-- Description (only for Reset Password) -->
    @if (isRegister === 2) {
      <p class="form-description">{{ 'auth.resetPassword.description' | transloco }}</p>
    }

    <!-- Form (for non-MFA modes) -->
    @if (isRegister !== 4) {
    <form
      [formGroup]="authForm"
      (ngSubmit)="onSubmit()"
      (keydown.enter)="submitOnEnterSafe($event)"
    >
      @for (field of formFields; track field) {
        <!-- Email -->
        @if (field === 'email') {
          <div class="field">
            <app-input
              [placeholder]="'auth.placeholders.email' | transloco"
              [icon]="'envelope'"
              [size]="inputSize"
              formControlName="email"
              class="custom-input"
              [error]="!!authForm.get('email')?.invalid && !!authForm.get('email')?.touched"
              [errorMessage]="getErrorMessage('email') || ''"
            ></app-input>
          </div>
        }

        <!-- Password (for login and create account) -->
        @if ((isRegister !== 2) && field === 'password') {
          <div class="field">
            <app-password
              [placeholder]="'auth.placeholders.password' | transloco"
              [icon]="'lock'"
              [size]="inputSize"
              formControlName="password"
              class="custom-password"
              [error]="!!authForm.get('password')?.invalid && !!authForm.get('password')?.touched"
              [errorMessage]="getErrorMessage('password') || ''"
              autocomplete="current-password"
            ></app-password>
            @if (isRegister === 1) {
              <!-- "Olvide la contrasena" esta OCULTO a proposito: el flujo de reset no
                   esta cableado aun (el modal recogia el email y no llamaba a nada).
                   Para reactivarlo: cablear onForgotPasswordSubmit y restaurar este enlace. -->
            }
          </div>
        }

        <!-- New Password (for reset-password-confirm) -->
        @if (field === 'newPassword') {
          <div class="field">
            <app-password
              [placeholder]="'auth.changePassword.newPassword' | transloco"
              [icon]="'lock'"
              [size]="inputSize"
              formControlName="newPassword"
              class="custom-password"
              [error]="!!authForm.get('newPassword')?.invalid && !!authForm.get('newPassword')?.touched"
              [errorMessage]="getErrorMessage('newPassword') || ''"
              [showTooltip]="true"
              autocomplete="new-password"
            ></app-password>
          </div>
        }

        <!-- Confirm Password (for reset-password-confirm) -->
        @if (isRegister === 3 && field === 'confirmPassword') {
          <div class="field">
            <app-password
              [placeholder]="'auth.changePassword.confirmPassword' | transloco"
              [icon]="'lock'"
              [size]="inputSize"
              formControlName="confirmPassword"
              class="custom-password"
              [error]="!!authForm.get('confirmPassword')?.invalid && !!authForm.get('confirmPassword')?.touched"
              [errorMessage]="getErrorMessage('confirmPassword') || ''"
              autocomplete="new-password"
            ></app-password>
          </div>
        }
      }

      <!-- Submit Button -->
      <app-button
        [label]="isRegister === 1 ? ('auth.login.button' | transloco) :
                 isRegister === 2 ? ('auth.resetPassword.button' | transloco) :
                 ('auth.changePassword.button' | transloco)"
        (click)="onSubmit()"
        [size]="inputSize"
        [loading]="loading"
        class="full-width-button"
      ></app-button>

      @if (showDevLogin) {
        <div class="dev-login-wrapper">
          <button
            type="button"
            class="dev-login-button"
            [disabled]="loading"
            (click)="toggleDevLoginMenu()"
          >
            {{ 'auth.login.devLogin.button' | transloco }}
          </button>

          @if (devLoginMenuOpen) {
            <div class="dev-login-menu">
              @for (user of devLoginUsers; track user.email) {
                <button
                  type="button"
                  class="dev-login-user"
                  [disabled]="loading"
                  (click)="onDevLogin(user)"
                >
                  <span class="dev-login-user-label">{{ user.label }}</span>
                  <span class="dev-login-user-meta">{{ user.role || user.email }}</span>
                </button>
              }
            </div>
          }
        </div>
      }
    </form>
    } @else {
    <!-- MFA Form (uses same structure as regular form) -->
    <form (ngSubmit)="onMfaSubmit()" (keydown.enter)="$event.preventDefault(); onMfaSubmit()">
      <div class="mfa-code-container">
        @for (digit of mfaCode; track $index) {
          <div class="mfa-code-box">
            <input
              type="text"
              inputmode="numeric"
              pattern="[0-9]"
              maxlength="1"
              [id]="'mfa-' + $index"
              [value]="digit"
              (input)="onMfaInput($event, $index)"
              (keydown)="onMfaKeydown($event, $index)"
              (focus)="onMfaFocus($event)"
              autocomplete="off"
            />
          </div>
        }
      </div>

      <!-- Error message -->
      @if (errorMessage) {
        <div class="error-message">
          {{ errorMessage }}
        </div>
      }

      <!-- Trust device checkbox -->
      <div class="trust-device-wrapper">
        <app-checkbox
          [(ngModel)]="trustDevice"
          [ngModelOptions]="{standalone: true}"
          [label]="'auth.login.mfa.trustDevice' | transloco"
        ></app-checkbox>
      </div>

      <!-- MFA Verify Button (same style as login button) -->
      <app-button
        [label]="'auth.login.mfa.verify' | transloco"
        (click)="onMfaSubmit()"
        [size]="inputSize"
        [loading]="loading"
        class="full-width-button"
      ></app-button>
    </form>
    }

    <!-- Bottom links -->
    @if (isRegister === 2 || isRegister === 3) {
      <app-button
        [label]="isRegister === 2 ? ('auth.resetPassword.backToLogin' | transloco) : ('auth.resetPasswordConfirm.backToLogin' | transloco)"
        (onClick)="navigateToLogin()"
        variant="link"
        [size]="inputSize"
        class="bottom-link"
      />
    }


    @if (isRegister === 4) {
      <app-button
        [label]="'common.actions.cancel' | transloco"
        (onClick)="onCancelMFA()"
        variant="link"
        [size]="inputSize"
        class="bottom-link"
      />
    }

    } @else {
      <!-- Success state (for reset-password-confirm) -->
      <div class="success-container">
        <div class="success-icon">
          <lucide-icon name="CircleCheck" class="check"></lucide-icon>
        </div>
        <h2 class="success-title">{{ 'auth.resetPasswordConfirm.success.title' | transloco }}</h2>
        <p class="success-message">{{ 'auth.resetPasswordConfirm.success.message' | transloco }}</p>
        <app-button
          [label]="'auth.resetPasswordConfirm.success.button' | transloco"
          (onClick)="navigateToLogin()"
          class="full-width-button"
          [size]="inputSize"
        ></app-button>
      </div>
    }

    </div>
    <!-- End white content wrapper -->

    <!-- Forgot Password Modal -->
    <app-forgot-password-modal
      [(show)]="showForgotPasswordModal"
      (submit)="onForgotPasswordSubmit($event)">
    </app-forgot-password-modal>
    </div>

    <!-- Brand panel (desktop and tablet) -->
    <aside class="auth-panel" aria-hidden="true">
      <div class="auth-panel__marca">
        <img src="assets/layout/images/branding/gainkode-logo-negativo.svg" alt="" />
        <span>{{ 'layout.pulso.brand' | transloco }}</span>
      </div>
      <div class="auth-panel__cuerpo">
        <p class="auth-panel__titular">{{ 'auth.panel.headline' | transloco }}</p>
        <ul class="auth-panel__lista">
          <li>{{ 'auth.panel.one' | transloco }}</li>
          <li>{{ 'auth.panel.two' | transloco }}</li>
          <li>{{ 'auth.panel.three' | transloco }}</li>
        </ul>
      </div>
      <div class="auth-panel__dato">
        <span class="auth-panel__punto"></span>
        {{ 'auth.panel.status' | transloco }}
      </div>
    </aside>
  </div>
</div>
